// extracted by mini-css-extract-plugin
module.exports = {"container":"MagicLinkLanding-module__container___154RZ","message":"MagicLinkLanding-module__message___3IRK3","button":"MagicLinkLanding-module__button___8Sln_"};